import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function CircularIndeterminate({customMargin}) {
    return (        
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: !customMargin ? 300 : customMargin,
            fontSize: 50
        }} >
            <CircularProgress style={{fontSize:60}} />
        </div>
    );
}